var React = require('react');

function Mileage (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M28 19.855C28 13.308 22.628 8 16 8 9.373 8 4 13.308 4 19.855c0 6.548 24 6.548 24 0zm3 0c0 10.548-30 10.548-30 0C1 11.643 7.724 5 16 5s15 6.643 15 14.855zM15.723 18.52l1.842-4.872a1 1 0 1 1 1.87.707l-1.858 4.916a2 2 0 1 1-1.854-.751zM16 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5.5 1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM7 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm15.5-8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM25 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"}));
}

Mileage.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Mileage;

Mileage.default = Mileage;
